module.exports = __webpack_public_path__ + "ha.png?cdc4d7d2b2d5238b35eb39299b47caef";